import { openBlock as _, createElementBlock as p, renderSlot as f } from "vue";
const d = navigator.userAgent.toLowerCase();
function a(t) {
  return Object.prototype.toString.call(t) === "[object Function]";
}
function u(t) {
  if (t) {
    if (t.resultString)
      return t.resultString;
    if (t.resultParams)
      return t.resultParams;
  } else
    return t;
}
const w = /\(securitywebcache\s([\d\.]+)\)/g.test(d), m = /\(cordova\s([\d\.]+)\)/g.test(d);
function h(t, e, i, n, o) {
  let r = !1;
  return m && window.cordova ? (r = !0, window.cordova.exec(t, e, i, n, o)) : w && window.WebViewJavascriptBridge && (r = !0, window.WebViewJavascriptBridge.callHandler(i, n, o, function(s) {
    a(t) && t(u(s));
  }, function(s) {
    a(e) && e(u(s));
  })), r;
}
const C = (t, e) => {
  const i = t.__vccOpts || t;
  for (const [n, o] of e)
    i[n] = o;
  return i;
}, b = {
  name: "UPButton",
  props: {
    scope: String,
    cardRule: String,
    timeout: Number
  },
  methods: {
    appletExplicitAuth(t, e) {
      h(function(n) {
        typeof t == "function" && t(n);
      }, function(n) {
        if (typeof e == "function") {
          let o;
          if (window.cordova)
            switch (window.cordova.errorRetStatus) {
              case window.cordova.callbackStatus.INVALID_ACTION:
                o = {
                  errcode: "c03",
                  errmsg: "INVALID_ACTION_EXCEPTION: 插件里面没有此方法！"
                };
                break;
              case window.cordova.callbackStatus.CLASS_NOT_FOUND_EXCEPTION:
                o = {
                  errcode: "c04",
                  errmsg: "CLASS_NOT_FOUND_EXCEPTION: 此插件没有实现！"
                };
                break;
              case window.cordova.callbackStatus.ILLEGAL_ACCESS_EXCEPTION:
                o = {
                  errcode: "c02",
                  errmsg: "ILLEGAL_ACCESS_EXCEPTION: 无权限访问此插件！"
                };
                break;
            }
          e(o || n);
        }
      }, "UPWebSdk", "appletExplicitAuth", [{ scope: this.scope, cardRule: this.cardRule || "" }]) || setTimeout(() => {
        this._count++, this._count > this._timeout / 20 ? (console.warn("请确定是否运行在云闪付APP中,且成功加载了upsdk.js"), e({
          errcode: "__ENV__10001",
          errmsg: "检测到未在云闪付APP中运行或未成功加载upsdk.js"
        })) : this.appletExplicitAuth(t, e);
      }, 20);
    },
    handleClick(t) {
      if (!this.btnDisable) {
        if (this.timeout && isNaN(parseInt(this.timeout))) {
          this.$emit("onClick", t, {
            errcode: "__ENV__10002",
            errmsg: "检测到timeout值非法"
          });
          return;
        }
        this._count = 0, this._timeout = this.timeout || 2e3, this.btnDisable = !0, this.appletExplicitAuth((e) => {
          this.btnDisable = !1, this.$emit("onClick", t, null, e);
        }, (e) => {
          this.btnDisable = !1, this.$emit("onClick", t, e);
        });
      }
    }
  }
};
function E(t, e, i, n, o, r) {
  return _(), p("button", {
    class: "up-button",
    onClick: e[0] || (e[0] = (...s) => r.handleClick && r.handleClick(...s))
  }, [
    f(t.$slots, "default", {}, void 0, !0)
  ]);
}
const c = /* @__PURE__ */ C(b, [["render", E], ["__scopeId", "data-v-8b0151f1"]]);
c.install = function(t) {
  t.component(c.name, c);
};
const S = [
  c
], l = (t) => {
  l.installed || S.map((e) => t.component(e.name, e));
};
typeof window < "u" && window.Vue && l(window.Vue);
const k = {
  install: l,
  UPButton: c
};
export {
  k as default
};
